import { render, staticRenderFns } from "./UpdateOrderComponent.vue?vue&type=template&id=651d05fe&"
import script from "./UpdateOrderComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports